import { X } from 'lucide-react';
import { useT } from '../i18n';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  destructive?: boolean;
}

export function ConfirmModal({ open, title, message, confirmLabel, onConfirm, onCancel, destructive }: ConfirmModalProps) {
  const { t } = useT();
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 360 }}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="close-btn" onClick={onCancel}><X size={16} /></button>
        </div>
        <div className="modal-body">
          <p style={{ margin: 0, fontSize: 'var(--t-13)', color: 'var(--ink-2)', lineHeight: 1.5 }}>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onCancel}>{t('common.cancel')}</button>
          <button
            className={`btn ${destructive ? 'btn-ghost' : 'btn-accent'}`}
            style={destructive ? { color: 'var(--err)' } : undefined}
            onClick={onConfirm}
          >
            {confirmLabel ?? t('common.delete')}
          </button>
        </div>
      </div>
    </div>
  );
}
